import Entity from './entity'

const ClientOwner = new Entity('clientowners')

export default ClientOwner
